import type { QueryClient } from '@tanstack/react-query';
import { SyncWorker } from './syncWorker';

let instance: SyncWorker | null = null;

export function initSyncWorker(queryClient: QueryClient): SyncWorker {
  if (!instance) {
    instance = new SyncWorker(queryClient);
    void instance.start(); // Fire-and-forget async start
  }
  return instance;
}

export function getSyncWorker(): SyncWorker | null {
  return instance;
}

export function stopSyncWorker(): void {
  instance?.stop();
  instance = null;
}
